module.exports = __webpack_public_path__ + "images/users/kaitori_focused_items/trading_cards/4_d240f0ca5aeae9adfad837a49e98c719.jpg";